export default __webpack_public_path__ + "static/media/secret.2ae7b947.svg";